const artistsWishlistHR = {
    "view": {
        "table": {
            "title": "Vaša lista želja izvođača",
            "column": {
                "artist_name": "Ime izvođača",
                "spotify_id": "Spotify ID",
                "followers": "Pratitelji",
                "popularity": "Popularnost (%)",
                "action": "Akcija"
            },
            "dropdown": {
                "action": "Akcija",
                "addAsArtist": "Dodaj kao izvođača",
                "delete": "Izbriši"
            },
            "button": {
                "export_csv": "Izvezi CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "message": {
                "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!"
            }
        },
        "modal": {
            "removeArtist": {
                "header": "Ukloni izvođača {{artistName}} s liste želja",
                "body": "Jeste li sigurni da želite ukloniti izvođača {{artistName}} s vaše liste želja?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija."
        }
    }
};

export default artistsWishlistHR;